export const RECENT_SEARCHES_KEY = 'recent_searches';
export const NUM_OF_RECENT_SEARCHES_IN_LOCAL_STORAGE = 10;
export const MAX_QUERY_LENGTH = 80;
export const NUM_OF_DISPLAYED_RECENT_SEARCHES = 3;

const ONE_DAY_IN_MS = 60 * 1000 * 60 * 24;
const NUM_OF_EXPIRATION_DAYS = 30; // 1 month
export const EXPIRATION_TIME_MS = ONE_DAY_IN_MS * NUM_OF_EXPIRATION_DAYS;
